import { Component } from '@angular/core';

@Component({
  selector: 'app-reports-general-header',
  templateUrl: './reports-general-header.component.html',
  styleUrls: ['./reports-general-header.component.scss'],
  standalone: false,
})
export class ReportsGeneralHeaderComponent {}
